import { Anchor, Group, Stack, Text } from "@mantine/core";
import {
  IconBriefcase,
  IconChartBar,
  IconFile,
  IconHeartRateMonitor,
  IconLicense,
  IconWritingSign,
} from "@tabler/icons-react";

const DOCS = [
  { label: "Презентация", icon: <IconHeartRateMonitor /> },
  { label: "Финмодель", icon: <IconChartBar /> },
  { label: "Устав", icon: <IconLicense /> },
  { label: "ДСУР", icon: <IconFile /> },
  { label: "Решение о выпуске ценных бумаг", icon: <IconWritingSign /> },
  { label: "Инвестиционное предложение", icon: <IconBriefcase /> },
];
export const ProjectDocsBlock = () => {
  const docs = DOCS.map((doc, index) => (
    <Anchor key={index} target={"_blank"} href={"/"}>
      <Group gap={5}>
        {doc.icon}
        <Text>{doc.label}</Text>
      </Group>
    </Anchor>
  ));

  return <Stack>{docs}</Stack>;
};
